export const ERROR_VISIBLE = 'ERROR_VISIBLE';
export const ERROR_INVISIBLE = 'ERROR_INVISIBLE';
